(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobilplate-image-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-mobilplate-image-hero]';
    const instances = new Map();

    const initialize = (hero) => {
      if (instances.has(hero)) return;

      const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
      if (!slides.length) return;

      const videos = slides.map((slide) => slide.querySelector('[data-hero-video]'));
      const triggers = Array.from(hero.querySelectorAll('[data-hero-video-trigger]'));
      const copies = Array.from(hero.querySelectorAll('[data-hero-copy]'));
      const autoRotate = hero.dataset.heroAutoRotate !== 'false';
      const listeners = new AbortController();
      const options = { signal: listeners.signal };
      let activeIndex = 0;
      let advanceTimer = null;
      let selectedBlock = false;

      const clearTimer = () => window.clearTimeout(advanceTimer);
      const pauseVideos = () => videos.forEach((video) => video?.pause());

      const playVideo = (video) => {
        if (!video || document.hidden) return;
        video.muted = true;
        video.playsInline = true;
        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      const scheduleAdvance = () => {
        clearTimer();
        if (selectedBlock || document.hidden || !autoRotate || slides.length < 2) return;

        const activeVideo = videos[activeIndex];
        const remaining = activeVideo && Number.isFinite(activeVideo.duration) && activeVideo.duration > 0
          ? activeVideo.duration - activeVideo.currentTime
          : 8;

        advanceTimer = window.setTimeout(() => {
          if (activeVideo && !activeVideo.ended && activeVideo.readyState >= 2 && !activeVideo.error) {
            scheduleAdvance();
          } else {
            setActive(activeIndex + 1);
          }
        }, Math.max(remaining, 1) * 1000 + 250);
      };

      const setActive = (index) => {
        clearTimer();
        activeIndex = ((index % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        videos.forEach((video, videoIndex) => {
          if (!video) return;
          if (videoIndex === activeIndex) {
            video.currentTime = 0;
            playVideo(video);
          } else {
            video.pause();
          }
        });
        triggers.forEach((trigger, triggerIndex) => {
          const active = triggerIndex === activeIndex;
          trigger.classList.toggle('is-active', active);
          trigger.setAttribute('aria-pressed', String(active));
        });
        copies.forEach((copy, copyIndex) => {
          const active = copyIndex === activeIndex;
          copy.classList.toggle('is-active', active);
          copy.inert = !active;
        });
        scheduleAdvance();
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => setActive(Number(trigger.dataset.heroVideoTrigger || 0)), options);
      });

      videos.forEach((video, index) => {
        if (!video) return;
        video.addEventListener('ended', () => {
          if (index === activeIndex && !selectedBlock) {
            setActive(autoRotate ? activeIndex + 1 : activeIndex);
          }
        }, options);

        ['loadedmetadata', 'playing', 'error'].forEach((eventName) => {
          video.addEventListener(eventName, () => {
            if (index === activeIndex) scheduleAdvance();
          }, options);
        });
      });

      instances.set(hero, {
        select: (blockId) => {
          const index = copies.findIndex((copy) => copy.dataset.heroBlockId === blockId);
          if (index < 0) return;
          selectedBlock = true;
          setActive(index);
        },
        deselect: () => {
          selectedBlock = false;
          playVideo(videos[activeIndex]);
          scheduleAdvance();
        },
        visibilityChanged: () => {
          clearTimer();
          if (document.hidden) {
            pauseVideos();
          } else {
            playVideo(videos[activeIndex]);
            scheduleAdvance();
          }
        },
        destroy: () => {
          clearTimer();
          pauseVideos();
          listeners.abort();
          instances.delete(hero);
        },
        resume: () => {
          playVideo(videos[activeIndex]);
        }
      });

      setActive(0);
    };

    const initializeWithin = (scope) => {
      if (scope.matches?.(selector)) initialize(scope);
      scope.querySelectorAll(selector).forEach(initialize);
    };

    document.addEventListener('shopify:section:load', (event) => {
      instances.forEach((instance, hero) => {
        if (!hero.isConnected) instance.destroy();
      });
      initializeWithin(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      instances.forEach((instance, hero) => {
        if (event.target.contains(hero)) instance.destroy();
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      instances.get(event.target.closest(selector))?.select(event.detail.blockId);
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      instances.get(event.target.closest(selector))?.deselect();
    });

    document.addEventListener('visibilitychange', () => {
      instances.forEach((instance) => instance.visibilityChanged());
    });

    document.addEventListener('pointerdown', () => {
      instances.forEach((instance) => instance.resume());
    }, { once: true, passive: true });

    initializeWithin(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
